
import { useState, useEffect } from 'react';

interface Slide {
  type: 'video' | 'image';
  src: string;
  title: string;
  buttonText: string;
}

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const slides: Slide[] = [
    {
      type: 'video',
      src: 'https://public.readdy.ai/ai/img_res/5e26a7501e70e10e8d3f6f9e4b866fdc.jpg',
      title: 'С нами мечты становятся маршрутами',
      buttonText: 'За мечтой'
    },
    {
      type: 'image',
      src: 'https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20Caucasus%20mountains%20with%20snow-capped%20peaks%2C%20green%20alpine%20meadows%20in%20foreground%2C%20dramatic%20mountain%20landscape%2C%20professional%20travel%20photography%2C%20vibrant%20natural%20colors%2C%20clear%20blue%20sky%2C%20sense%20of%20adventure%20and%20exploration&width=1920&height=800&seq=hero-slide-2&orientation=landscape',
      title: 'Авторские туры по Кавказу',
      buttonText: 'Забронировать'
    },
    {
      type: 'image',
      src: 'https://readdy.ai/api/search-image?query=Breathtaking%20Iceland%20landscape%20with%20volcanic%20terrain%2C%20dramatic%20waterfalls%2C%20green%20moss-covered%20lava%20fields%2C%20majestic%20mountains%20in%20background%2C%20professional%20travel%20photography%2C%20vibrant%20natural%20colors%2C%20sense%20of%20adventure%20and%20wonder&width=1920&height=800&seq=hero-slide-3&orientation=landscape',
      title: 'Вокруг Исландии за 10 дней',
      buttonText: 'Забронировать'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isHovered, slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div 
      className="relative h-[600px] lg:h-[700px] overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {slide.type === 'video' ? (
            <div className="relative w-full h-full">
              <img
                src={slide.src}
                alt={slide.title}
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <img
              src={slide.src}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          )}
          
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4 max-w-4xl">
              <h1 className="font-mulish font-bold text-4xl md:text-5xl lg:text-6xl text-white mb-8 leading-tight">
                {slide.title}
              </h1>
              <button className="bg-[#1E88E5] hover:bg-[#0D47A1] text-white font-open-sans font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
                {slide.buttonText}
              </button>
            </div>
          </div>
        </div>
      ))}

      {isHovered && (
        <>
          <button
            onClick={prevSlide}
            className="absolute left-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all duration-300 cursor-pointer z-10"
          >
            <i className="ri-arrow-left-s-line text-2xl text-white"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-6 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all duration-300 cursor-pointer z-10"
          >
            <i className="ri-arrow-right-s-line text-2xl text-white"></i>
          </button>
        </>
      )}

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
